import { cn } from "@/lib/utils";

const STYLES = {
  "New / Brand New / In Box (NIB)": "bg-success text-ink",
  "Like New / Mint Condition": "bg-success text-ink",
  "New Other / Scratch and Dent": "bg-discount text-ink",
  "Floor Model / Display": "bg-discount text-ink",
  "Good / Fair Condition / Tested & Working": "bg-discount text-ink",
  "Used / Pre-owned / Tested & Working": "bg-link text-white",
  "As-Is / Untested / Salvage / For Parts": "bg-danger text-white",
};

const SHORT = {
  "New / Brand New / In Box (NIB)": "NEW / NIB",
  "Like New / Mint Condition": "LIKE NEW",
  "New Other / Scratch and Dent": "SCRATCH & DENT",
  "Floor Model / Display": "FLOOR MODEL",
  "Good / Fair Condition / Tested & Working": "GOOD / FAIR",
  "Used / Pre-owned / Tested & Working": "USED",
  "As-Is / Untested / Salvage / For Parts": "AS-IS / FOR PARTS",
};

export const CONDITION_SHORT = SHORT;

export function ConditionBadge({ condition, className }) {
  const style = STYLES[condition] || "bg-ink text-white";
  const label = SHORT[condition] || condition;
  return (
    <span
      data-testid="condition-badge"
      title={condition}
      className={cn("inline-block font-mono text-[10px] font-bold uppercase tracking-[0.12em] px-2 py-1 border border-ink whitespace-nowrap", style, className)}
    >
      {label}
    </span>
  );
}
